import { TextField, FormControl } from "@mui/material";
import { DropdownCheck, DropdownClear } from "../../Icons/Icons.jsx";
import React, { useState } from "react";

interface NumericFilterProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  onClear: () => void;
  className?: string;
}

const NumericFilter = ({ label, value, onChange, onClear, className }: NumericFilterProps) => {
  const [inputValue, setInputValue] = useState(value === "undefined" ? "" : value);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    // Only allow numbers and decimal points
    if (newValue === "" || /^\d*\.?\d*$/.test(newValue)) {
      setInputValue(newValue);
    }
  };

  const applyFilter = () => {
    if (inputValue) {
      onChange(inputValue);
    } else {
      onClear();
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter') {
      applyFilter();
    }
  };

  return (
    <div className={`flex drop-down-wrapper ${className || ""}`}>
      <FormControl size="small" focused={false}>
        <div className="numeric-filter">
          {inputValue && (
            <span className="start-adornment">
              <DropdownCheck />
            </span>
          )}
          <TextField
            size="small"
            value={inputValue}
            onChange={handleChange}
            onBlur={applyFilter}
            onKeyDown={handleKeyDown}
            placeholder={`${label}`}
            className="numeric-input"
          />
          <span className="end-adornment" onClick={onClear}>
            <DropdownClear />
          </span>
        </div>
      </FormControl>
    </div>
  );
};

export default NumericFilter; 